import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { CancelChannel } from "api/Channel/CancelChannel";
import CoreInput from "common/components/forms_context/CoreInput";
import { useModalState } from "common/hooks/useModalState";
import { queryKeys } from "helper/react-query";
import { checkRegexExpSpecial } from "helper/utils";
import _ from "lodash";
import { Option } from "modules/Channel/configs/constant";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

const CancelAccount = ({ setIsShowInfo }) => {
  const { t } = useTranslation("uaa");
  const { getValues, reset } = useFormContext();
  const queryClient = useQueryClient();

  const { mutateAsync: cancelChannel, isLoading } = useMutation({
    mutationKey: queryKeys.CANCEL_CHANNEL,
    mutationFn: CancelChannel.requestCancel,
  });

  const { isShow, handleClose, handleOpen } = useModalState();

  const onCancelAccount = async () => {
    const FIELD_REQUEST = [
      "accountBalance",
      "accountState",
      "currencyCode",
      "cancelReason",
      "accountId",
      "channelId",
    ];

    const FIELD_DATA = [
      "channelName",
      "phoneNumber",
      "phoneNumberSearch",
      "channelType",
      "walletState",
      "channelState",
      "accountAR",
      "accountBalance",
      "accountState",
      "cancelAccountType",
      "channelId",
      "accountId",
      "currencyCode",
      "cancelReason",
    ];

    const payload = _.pick(getValues(), FIELD_REQUEST);
    const formData = _.pick(getValues(), FIELD_DATA);
    const { data } = await cancelChannel(payload);

    if (data) {
      if (
        !!data.errorCodes ||
        data.status === 404 ||
        data.status === 500 ||
        data.status === 504
      ) {
        reset({ ...formData, channelTypeIdSearch: Option.ALL });
      } else {
        toast.success(t(`message.cancel-successfully`));
        setIsShowInfo(false);
        // setIsSearch(false);
        reset({
          channelTypeIdSearch: Option.ALL,
        });
      }
      queryClient.removeQueries({
        queryKey: queryKeys.GET_CHANNEL_INFO,
        exact: false,
      });
      handleClose();
    }
  };

  return (
    <>
      <Typography>{t(`header.cancel-account`)}</Typography>
      <Box className="grid desktop:grid-cols-4 tablet:grid-cols-3 mobile:grid-cols-1 gap-4 mt-8">
        <CoreInput
          name="cancelAccountType"
          label={t(`label.cancel-account-type`)}
          //   required
          disabled
        />

        <CoreInput
          name="cancelReason"
          label={t(`label.reason`)}
          inputProps={{ maxLength: 250 }}
          rules={{
            validate: (value) => {
              if (!!value && checkRegexExpSpecial(value)) {
                // return `${t("message.msg-error-not-special", {
                //   label: t("label.reason"),
                // })}`;
                return "message.msg-error-not-special";
              }
            },
          }}
        />
        <div></div>
        <div className="flex justify-end">
          <LoadingButton
            variant="contained"
            color="success"
            onClick={handleOpen}
            // loading={isLoading}
            className="text-right px-12 py-6 h-25 "
          >
            {t("btn.request-cancel")}
          </LoadingButton>
        </div>

        {isShow ? (
          <Dialog
            open={isShow}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">
              {t(`title.confirmation`)}
            </DialogTitle>
            <DialogContent>
              <>
                <p style={{ maxWidth: "30rem" }}>
                  {t(`message.confirm-cancel-channel`)}
                </p>
                <div className="flex justify-center">
                  <LoadingButton
                    variant="contained"
                    color="success"
                    className="py-6 px-12 h-21 mx-6"
                    loading={isLoading}
                    disabled={isLoading}
                    onClick={onCancelAccount}
                    // onClick={() => {
                    //   btnSubmitRef.current.click();
                    // }}
                  >
                    {t(`btn.yes`)}
                  </LoadingButton>
                  <Button
                    variant="contained"
                    color="error"
                    className="py-6 px-12 h-21 mx-6"
                    onClick={handleClose}
                  >
                    {t(`btn.no`)}
                  </Button>
                </div>
              </>
            </DialogContent>
          </Dialog>
        ) : null}
      </Box>
    </>
  );
};

export default CancelAccount;
